/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const JiraTypesGet = {
  id: 'jira-types.get',
  tag: 'Support',
  summary: 'Jira types',
  description: 'Get jira types',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/jira/types`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              name: z.string(),
              description: z.string(),
              issueTypeId: z.string(),
              serviceDeskId: z.string(),
              portalId: z.string(),
              groupIds: z.array(z.string()),
              icon: z.string(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
